let triplaTier = null

export function setTier(tier) {
  triplaTier = tier
}

export function getTier() {
  return triplaTier
}
